//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start
import apiCall from "./axios_instance";
import config from "../config.json";
import { ALERT_VERSION } from '../utils/global_variables';

export async function getUserAlerts(user_id) {
    try {
        const objresp = await apiCall.get(`${config.Wave.URL}/alert-nodeengine/${config.TenantId}/${ALERT_VERSION}/alerts/getUserAlerts/${user_id}`);
        return objresp;

    } catch (error) {
        console.error('error in getAlaer Api', error);
    }
}

export async function setScripAlerts(payload) {
    try {
        const objresp = await apiCall.post(`${config.Wave.URL}/alert-nodeengine/${config.TenantId}/${ALERT_VERSION}/alerts/setScripAlert`, payload);
        return objresp;
    } catch (error) {
        console.error('error in setScripAlerts API', error);
        throw error;
    }
}

export async function modifyScripAlert(payload) {
    try {
        const objresp = await apiCall.put(`${config.Wave.URL}/alert-nodeengine/${config.TenantId}/${ALERT_VERSION}/alerts/setScripAlert`, payload);
        return objresp;
    } catch (error) {
        console.error('error in modifyScripAlert API', error);
        throw error;
    }
}

export async function deleteAlert(payload) {
    try {
        const objresp = await apiCall.delete(`${config.Wave.URL}/alert-nodeengine/${config.TenantId}/${ALERT_VERSION}/alerts/setScripAlert/${payload?.userID}/${payload?.serverAlertId}`);
        return objresp;
    } catch (error) {
        console.error('error in deleteAlert API', error);

    }
}
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End

//Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start
//delete api gor nesper alerts
export async function deleteMultipleAlerts(payload) {
    try {
        const objResp = apiCall.post(`/alert-nodeengine/${config.TenantId}}/${ALERT_VERSION}/alerts/deleteScripAlert`, payload);
        return objResp;
    } catch (error) {
        throw error;
    }
}
//Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End